export const collections = {
	projects: "projects",
	questionnaires: "questionnaires",
	questions: "questions",
	sharedProjects: "sharedProjects",
	liveSessions: "liveSessions",
	liveTeams: "liveTeams",
	liveAnswers: "liveAnswers",
	liveQuestionResults: "liveQuestionResults",
	quizParticipations: "quizParticipations",
	examInvitations: "examInvitations",
	examAttempts: "examAttempts",
	certificateTemplates: "certificateTemplates",
	signingCredentials: "signingCredentials",
	certificates: "certificates",
	projectMembers: "projectMembers",
} as const;
